export default class SeosConversion {

    constructor($view)
    {
        this.$view = $view;
        this.bind();
    }

    bind()
    {

        this.$view.on("click",".display-phone-number", (e) => {
            e.preventDefault();

            let $this = $(e.target);

            let $phoneContainer = $this.closest(".phone-container");

            $phoneContainer.find(".agency-phone").addClass("phone-displayed").show();
            $this.removeClass(function (index, className) {
                return (className.match (/(^|\s)gtm-\S+/g) || []).join(" ");
            });

            $phoneContainer.find("a.display-phone-number").addClass("phone-displayed").removeClass("d-none").removeClass("d-md-flex").hide();
        });

        $(window).on("load resize orientationchange", (e) => {

            if($(window).width() < 768){
                this.$view.find(".agency-phone").show();
            }else{
                this.$view.find(".agency-phone:not(.phone-displayed)").hide();
            }
        });

    }
}